<ion-content>
  <app-header [title]="'Route Log Comments Admin'"></app-header>

  <div class="loading-container" *ngIf="!loading" style="padding-top: 10%;">
    <ion-spinner></ion-spinner>
  </div>

  <ion-content class="ion-padding" *ngIf="loading">
    <form  style="padding-top: 70px">

     <ion-row>
          <ion-col size="12">
            <ion-text color="medium">
              <b>The following are comments which drivers can add to a stop.</b><br>
              <b>You can change and reorder the comments below.</b>
            </ion-text>
          </ion-col>
        </ion-row>
      <ion-grid>
        <ion-row class="table-header ion-text-center">
          <ion-col size="2"><strong>ID</strong></ion-col>
          <ion-col size="7"><strong>Comment</strong></ion-col>
          <ion-col size="3"><strong>Display Order</strong></ion-col>
        </ion-row>
      <ion-row style="padding-top:1px">
        <ion-col size="2">
          </ion-col>
          <ion-col size="10" style="background-color:rgb(223, 223, 208);">
            <ion-text color="medium">
              <b>To remove a comment, clear the comment text field</b>
            </ion-text>
          </ion-col>
        </ion-row>
        <ion-row
          *ngFor="let item of routeComments; let i = index"
          class="ion-align-items-center ion-padding-vertical"
        >
          <ion-col size="2" class="ion-text-center">
            {{ item.seqNum }}
          </ion-col>

          <ion-col size="7">
            <ion-input type="text"
              fill="outline"
              [(ngModel)]="item.comment"
              name="comment{{ i }}"
              placeholder="Enter comment"
            ></ion-input>
          </ion-col>

          <ion-col size="3">
            <ion-input
              fill="outline"
              type="number"
              [(ngModel)]="item.displayOrder"
              name="displayOrder{{ i }}"
              placeholder="Order"
            ></ion-input>
          </ion-col>
        </ion-row>

         <ion-row>
          <ion-col size="2">
          </ion-col>
          <ion-col size="10" style="background-color:rgb(223, 223, 208);">
            <ion-text color="medium">
              <b>	To add a new comment enter data below</b>
            </ion-text>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col size="2">
          </ion-col>

          <ion-col size="7">
            <ion-input
              fill="outline"
              [(ngModel)]="Add_Text1"
            ></ion-input>
          </ion-col>

          <ion-col size="3">
            <ion-input
              fill="outline"
              type="number"
              [(ngModel)]="Add_Display_Order1"
            ></ion-input>
          </ion-col>
        </ion-row>
         <ion-row>
          <ion-col size="2">
          </ion-col>

          <ion-col size="7">
            <ion-input
              fill="outline"
              [(ngModel)]="Add_Text2"
            ></ion-input>
          </ion-col>

          <ion-col size="3">
            <ion-input
              fill="outline"
              type="number"
              [(ngModel)]="Add_Display_Order2"
            ></ion-input>
          </ion-col>
        </ion-row>

        <ion-row class="ion-justify-content-end ion-padding-top">
          <ion-col size="auto">
            <ion-button type="submit" (click)="submitForm()" color="primary">Save</ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>
    </form>
  </ion-content>
</ion-content>
